export function fetchPlacements(state, { page, sort, filter }) {
  return {
    ...state,
    placements: {
      ...state.placements,
      currentPage: page,
      sort: sort || state.placements.sort,
      filter: filter || state.placements.filter,
    },
  };
}

export function fetchPlacementsSuccess(state, placements) {
  return {
    ...state,
    placements: {
      ...state.placements,
      numberOfPages: placements.numberOfPages,
      count: placements.count,
      items: placements.items,
    },
  };
}

export function openEditPlacement(state, placement) {
  return {
    ...state,
    editPlacement: {
      ...placement,
      showModal: true,
    },
  };
}

export function closeEditPlacement(state) {
  return {
    ...state,
    editPlacement: {
      showModal: false,
    },
  };
}

export function updatePlacementSuccess(state, { placementId, revShare }) {
  const placementIndex = state.placements.items.findIndex(x => x._id === placementId);
  const placement = state.placements.items.find(x => x._id === placementId);
  if (!placement) {
    return state;
  }
  return {
    ...state,
    placements: {
      ...state.placements,
      items: [
        ...state.placements.items.slice(0, placementIndex),
        {
          ...placement,
          revShare,
        },
        ...state.placements.items.slice(placementIndex + 1),
      ],
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/placements.js
 **/